import Video from './Video';

export { Props, VideoType } from './Video';
export default Video;
